var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareCaretLeftDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "square-caret-left-duotone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.311,
    height: 23.311,
    viewBox: "0 0 23.311 23.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M136.325,140.106a1.249,1.249,0,0,1-.75,1.145,1.278,1.278,0,0,1-.5.1,1.254,1.254,0,0,1-.85-.333L128.4,135.61a1.251,1.251,0,0,1,0-1.831l5.828-5.411a1.249,1.249,0,0,1,2.1.915Z",
    transform: "translate(-121.34 -123.039)",
    fill: "#0b182e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M19.981,32H3.33A3.33,3.33,0,0,0,0,35.33V51.981a3.33,3.33,0,0,0,3.33,3.33H19.981a3.33,3.33,0,0,0,3.33-3.33V35.33A3.332,3.332,0,0,0,19.981,32Zm-5,17.067a1.249,1.249,0,0,1-.75,1.145,1.278,1.278,0,0,1-.5.1,1.254,1.254,0,0,1-.85-.333L7.059,44.571a1.251,1.251,0,0,1,0-1.831l5.828-5.411a1.249,1.249,0,0,1,2.1.915Z",
    transform: "translate(0 -32)",
    fill: "#0b182e",
    opacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCaretLeftDuotone);
export default __webpack_public_path__ + "static/media/square-caret-left-duotone.9aa5f1e5344e750580fc1b1c3bf02c06.svg";
export { ForwardRef as ReactComponent };